import { types as sdkTypes } from './sdkLoader';
import { convertUnitToSubUnit, unitDivisor } from './currency';

const { Money } = sdkTypes;

/**
 * Normaliza publicData.extras (multi-enum) a array de claves de opción.
 */
export const normaliseListingExtrasKeys = extras => {
  if (extras == null) return [];
  if (Array.isArray(extras)) {
    return extras.map(k => String(k));
  }
  return [String(extras)];
};

/**
 * Coincide con claves de consola tipo "Barbecue", "pub_extras.Barbecue", etc.
 */
const matchesCanonicalExtraKey = (selectedKeys, canonical) => {
  const c = String(canonical).toLowerCase();
  return selectedKeys.some(raw => {
    const s = String(raw).toLowerCase();
    if (s === c) return true;
    const dot = s.lastIndexOf('.');
    if (dot >= 0 && s.slice(dot + 1) === c) return true;
    const und = s.lastIndexOf('_');
    if (und >= 0 && s.slice(und + 1) === c) return true;
    return false;
  });
};

const moneyFromMainUnits = (mainUnits, marketplaceCurrency) => {
  const divisor = unitDivisor(marketplaceCurrency);
  const amount = convertUnitToSubUnit(mainUnits, divisor);
  return new Money(amount, marketplaceCurrency);
};

/**
 * Definición de extras de pago sugeridos según extras del espacio (paso Detalles).
 * unitAmountMain: importe en unidad principal (ej. 25 → 25 €).
 */
const PAID_EXTRA_SUGGESTION_DEFS = [
  {
    id: 'paid-extra-barbecue',
    ifSelectedKeys: ['Barbecue'],
    nameMessageId: 'EditListingPricingForm.suggestedExtraBarbecue',
    unitAmountMain: 25,
  },
  {
    id: 'paid-extra-charcoal',
    ifSelectedKeys: ['Barbecue'],
    nameMessageId: 'EditListingPricingForm.suggestedExtraCharcoal',
    unitAmountMain: 5,
  },
  {
    id: 'paid-extra-refrigerator',
    ifSelectedKeys: ['Refrigerator'],
    nameMessageId: 'EditListingPricingForm.suggestedExtraRefrigerator',
    unitAmountMain: 5,
  },
];

/**
 * @param {string[]} selectedExtrasKeys - valores guardados en publicData.extras
 * @param {string} marketplaceCurrency
 * @param {(descriptor: { id: string }) => string} formatMessage - p. ej. intl.formatMessage
 */
export const buildPaidExtraSuggestions = (
  selectedExtrasKeys,
  marketplaceCurrency,
  formatMessage
) => {
  const keys = normaliseListingExtrasKeys(selectedExtrasKeys);
  if (!keys.length || !marketplaceCurrency) return [];

  const out = [];
  for (const def of PAID_EXTRA_SUGGESTION_DEFS) {
    const match = def.ifSelectedKeys.some(canonical => matchesCanonicalExtraKey(keys, canonical));
    if (!match) continue;
    out.push({
      _suggestionId: def.id,
      itemName: formatMessage({ id: def.nameMessageId }),
      itemPrice: moneyFromMainUnits(def.unitAmountMain, marketplaceCurrency),
    });
  }
  return out;
};

/**
 * Excluye sugerencias ya presentes (por id interno o nombre igual al sugerido por defecto).
 */
export const filterNewPaidExtraSuggestions = (existingItems, suggestions) => {
  const existing = Array.isArray(existingItems) ? existingItems : [];
  return suggestions.filter(sug => {
    const id = sug._suggestionId;
    const defaultName = (sug.itemName || '').trim().toLowerCase();
    return !existing.some(item => {
      if (item._suggestionId && id && item._suggestionId === id) return true;
      const n = (item.itemName || '').trim().toLowerCase();
      return defaultName.length > 0 && n === defaultName;
    });
  });
};
